import React from 'react';
import '../tailwind.css';
import '../stitches.css';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import PIs from '../components/PIs';
import POs from '../components/POs';
const PIlist = require('../components/PI.json');
const PIDCClist = require('../components/DCCPI.json');

export default() => (
    <div className='flex flex-col justify-between h-screen'>
        <div className='border-b-2 border-grey-light'>
            <Nav/>
        </div>

        <div>
            <div
                className="pt-8 font-sans container m-auto flex flex-col md:flex-row max-w-xl px-6 lg:px-0 block items-center">
                <div
                    className="w-full md:w-1/4 border-b md:border-0 mb-6 md:mb-0 pb-6 md:pb-0 pr-8 flex justify-center items-start flex-col">
                    <p
                        className="leading-normal mt-4 border-0 md:border-r md:pr-2 h-16 flex flex-col justify-center items-center py-8">
                        <label className="font-bold ">Research Objective</label>

                    </p>

                </div>
                <div className="w-full md:w-3/4 leading-normal column-0 lg:column-2 mt-4">In
                    2012, the NIEHS established the multi-phased Toxicant Exposures and Responses by
                    Genomic and Epigenomic Regulators of Transcription (TaRGET) Program to further
                    address the role of the environment in disease susceptibility as a function of
                    changes to the epigenome. The first phase of this program, TaRGET I
                    (RFA-ES-12-008, TaRGET I: Chromatin Structure, Genomics, and Transcriptional
                    Responses to the Environment), solicited and funded applications that support
                    environmental health scientists' pursuit of research objectives aimed at
                    understanding the environmental control of epigenetic mechanisms. These grants
                    consider the impact of environmental toxicants on the following processes:
                    nucleosome positioning, chromatin accessibility, chromatin remodeling and the
                    role of non-coding RNAs. However, identifying exposure-induced changes in
                    tissues/cells affected by disease is not always feasible in humans. The purpose
                    of this Funding Opportunity Announcement is to establish the TaRGET II
                    Consortium which will assess the utility of surrogate tissue epigenomic analysis
                    as a means to examine the role of environmental exposures on epigenomic marks in
                    target tissues. The goals are: to enhance our understanding of the relationship
                    between exposure-induced perturbations of epigenetic marks in target versus
                    surrogate tissues; determine conditions where these studies will be valid; and
                    aid in the interpretation of the results of such studies. Applications submitted
                    in response to this FOA must propose aims that focus on disease relevant
                    environmental exposures and evaluate epigenomic changes or patterns of changes
                    in surrogates that may serve as potential biomarkers of exposure associated
                    pathologies. This FOA is published in parallel with a companion FOA, RFA
                    ES-015-002, TaRGET II: Environmental Epigenomics Data Coordination Center (U24).
                    Projects funded by these FOAs will collectively form the TaRGET II Consortium
                    (T2C) and will develop a publically accessible database that provides data to
                    the broader scientific community on the conservation of environmental exposure
                    induced epigenomic changes in target tissues and cells and selected surrogates.
                </div>
            </div>
            <div className="font-sans text-center m-8 px-8">
                <h1 className="capitalize font-medium">TaRGET - II consortium RFA</h1>
                <p className="text-grey-dark mt-2"></p>
                <a className='pt-8 no-underline' href="https://grants.nih.gov/grants/guide/rfa-files/RFA-ES-15-001.html">
                <button
                    className="bg-black hover:bg-grey-darkest text-white hover:text-white py-3 px-8 m-8 uppercase text-xs tracking-wide">Learn More</button></a>

                <a
                    className='h-24 pt-8 no-underline'
                    href="https://www.niehs.nih.gov/research/supported/health/envepi/">
                    <button
                        className="bg-transparent hover:bg-black text-black font-semibold hover:text-white py-2 px-4 border border-black hover:border-transparent">Funded Research</button>
                </a>
                <div
                    className='container container max-w-xl m-auto flex flex-wrap flex-col md:flex-row items-center justify-center'>
                    <div
                        className='text-lg bg-white p-8 border-2 text-grey-darker m-8 rounded max-w-sm'>
                        Consortium Investigators
                    </div>
                    <PIs list={PIlist}/>
                </div>
                <div
                    className='container container max-w-xl m-auto flex flex-wrap flex-col md:flex-row items-center justify-center'>
                    <div
                        className='text-lg bg-white p-8 border-2 text-grey-darker m-8 rounded max-w-sm'>
                        Program Officers
                    </div>
                    <POs/>
                </div>

                <div
                    className='container container max-w-xl m-auto flex flex-wrap flex-col md:flex-row items-center justify-center'>
                    <div
                        className='text-lg bg-white p-8 border-2 text-grey-darker m-8 rounded max-w-sm'>
                        Investigators - DCC
                    </div>
                    <PIs list={PIDCClist}/>
                </div>
                <div className='bg-white p-8 border-2 text-grey-darker m-8 rounded'>
                <a
                    className='h-24 pt-8 no-underline'
                    href="https://grants.nih.gov/grants/guide/rfa-files/RFA-ES-15-002.html">
                    <button
                        className="bg-transparent hover:bg-black text-black font-semibold hover:text-white py-2 px-4 border border-black hover:border-transparent">TaRGET II DCC RFA</button>
                </a>
                <div className="m-8 p-4 text-grey-darker leading-loose container container max-w-xl m-auto flex flex-wrap flex-col md:flex-row items-center justify-center">The
                    TaRGET DCC is funded by a U24 grant from the National Institute of Environmental
                    Health Sciences at the U.S. National Institutes of Health. The content of this
                    web site is solely the responsibility of the contributors and does not
                    necessarily represent the official views of the National Institute of
                    Environmental Health Sciences or the National Institutes of Health.</div>
            </div>
            </div>
           

            <Footer/>
        </div>
    </div>

)